import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import './AuthStatusPage.scss';

// /login from the cutoff on (ENTRA_MIGRATION=cutoff or closed;
// docs/EntraFullMigrationPlan.md §3.2): no email and password, only the way to
// Microsoft. Existing users sign up there again with the same email and are
// linked to their account; new users take the same button and then onboarding.
export default function CutoffLogin() {
  const { loginWithEntra, authError } = useContext(UserContext);
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLeaving, setIsLeaving] = useState(false);

  const firstSignIn = async () => {
    setIsLeaving(true);
    setError('');
    try {
      await loginWithEntra({ intent: 'login', prompt: 'create', replaceHistory: true });
    } catch (startError) {
      console.error('Opening Microsoft sign-up failed:', startError);
      setError('לא הצלחנו לפתוח את דף ההרשמה. נסו שוב.');
      setIsLeaving(false);
    }
  };

  return (
    <div className="auth-status-page" dir="rtl">
      <h1>כניסה למשלום</h1>
      <p>משלום עברה לכניסה מאובטחת חדשה.</p>
      <p>
        <b>בפעם הראשונה</b> (גם אם יש לכם חשבון במשלום): לחצו &quot;כניסה ראשונה למערכת החדשה&quot;
        והירשמו עם <b>אותה כתובת מייל</b> שבה השתמשתם במשלום. תקבלו קוד למייל ותבחרו סיסמה.
        החשבון, ההרשאות והמחלקות שלכם נשמרים.
      </p>
      <p>נכנסתם בעבר עם Google? לחצו &quot;כבר עברתי – כניסה&quot; ובחרו Google.</p>
      {(error || authError) && <p role="alert" style={{ color: '#B42318' }}>{error || authError}</p>}
      <button type="button" className="auth-status-primary" onClick={firstSignIn} disabled={isLeaving}>
        {isLeaving ? 'מעביר...' : 'כניסה ראשונה למערכת החדשה'}
      </button>
      <button type="button" className="auth-status-secondary" onClick={() => navigate('/signin')} disabled={isLeaving}>
        כבר עברתי – כניסה
      </button>
      <p style={{ fontSize: '0.9rem' }}>
        אם מופיעה רשימת חשבונות של אחרים, בחרו &quot;השתמש בחשבון אחר&quot;.
      </p>
    </div>
  );
}
